// js-access-token-lib throws a plain Error with no type marker — message string is the only discriminator.
export const isAccessTokenRetrievalError = (error: unknown): boolean =>
	error instanceof Error && error.message === 'Could not retrieve access token';
